import { useActivityShortlists } from "PFApp/activities/show/hooks/use_activity_shortlists";
import { useShortlistsActions } from "PFApp/activities/show/store/shortlists";
import {
  FiltersV2StoreContextProvider,
  useApiFilters,
  useFiltersV2MetaAutoUpdate
} from "PFApp/components/filters_v2";
import { FiltersV2StorePage } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { Inline } from "PFComponents/containers";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { ShortlistMainPanel } from "./parts/shortlist_main_panel";
import { ShortlistSidePanel } from "./parts/shortlist_side_panel";

const ActivityShortlistContent = () => {
  const { t } = useTranslation("activities");
  const scrollableContainerRef = useRef<HTMLDivElement>(null);

  const { shortlistsMeta } = useActivityShortlists();
  const { updateShortlistsParams } = useShortlistsActions();
  const { apiFilters } = useApiFilters();
  useFiltersV2MetaAutoUpdate(shortlistsMeta);

  useEffect(() => {
    updateShortlistsParams({ filters: apiFilters, page: 1 });
  }, [apiFilters, updateShortlistsParams]);

  return (
    <Inline
      ref={scrollableContainerRef}
      gap="spacingLg"
      role="tabpanel"
      aria-label={t("show.tabs.shortlist")}
      qaId="ActivityPage.shortlistTab"
    >
      <ShortlistSidePanel scrollableContainerRef={scrollableContainerRef} />
      <ShortlistMainPanel />
    </Inline>
  );
};

export const ActivityShortlist = () => (
  <FiltersV2StoreContextProvider name={FiltersV2StorePage.ActivityShortlistPage}>
    <ActivityShortlistContent />
  </FiltersV2StoreContextProvider>
);
